import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["secondary", "onClose", "primaryLabelStyles", "iconShadow", "variant"];
import React from 'react';
import { intrinsicComponent } from '../../utils/functions';
import CrossButton from '../cross-button';
import Styled from './modal-title.styles';
import { Variant } from './types';
var ModalTitle = intrinsicComponent(function (_ref, ref) {
  var secondary = _ref.secondary,
    onClose = _ref.onClose,
    primaryLabelStyles = _ref.primaryLabelStyles,
    _ref$iconShadow = _ref.iconShadow,
    iconShadow = _ref$iconShadow === void 0 ? true : _ref$iconShadow,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? Variant.Default : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Styled.ModalTitle, _extends({}, rest, {
    variant: variant,
    ref: ref
  }), rest.icon && /*#__PURE__*/React.createElement(Styled.Icon, {
    iconShadow: Boolean(iconShadow)
  }, rest.icon), /*#__PURE__*/React.createElement(Styled.LabelPrimary, {
    variant: variant,
    style: primaryLabelStyles
  }, rest.primary), variant === Variant.WithIcon && secondary && /*#__PURE__*/React.createElement(Styled.LabelSecondary, null, secondary), /*#__PURE__*/React.createElement(Styled.Close, {
    variant: variant
  }, /*#__PURE__*/React.createElement(CrossButton, {
    size: "lg",
    onClick: onClose
  })));
});
ModalTitle.displayName = 'ModalTitle';
export default ModalTitle;